import React, { useEffect, useRef } from "react";
import { TIMELINE_DRAGGABLE_TIME_LINE_WIDTH, TIMELINE_PADDING } from "../core/layoutConstants";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import { useZoomStore } from "@shared/common/contexts/zoomLevel/useSbdZoom";

interface CurrentTimeLineProps {
  readonly stageHeight: number;
  readonly hourWidth: number;
  readonly focusKoppelingActive: boolean;
}

export function CurrentTimeLine({
  stageHeight,
  hourWidth,
  focusKoppelingActive,
}: CurrentTimeLineProps): React.JSX.Element {
  const currentTimeLineRef = useRef<HTMLDivElement>(null);
  const scenarioStart = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const selectedTime = useSelectedTimeStore((state) => state.selectedTime)!;
  const zoomLevel = useZoomStore((state) => state.zoomLevel);

  useEffect(() => {
    if (!focusKoppelingActive || !currentTimeLineRef.current) {
      return;
    }
    setTimeout(() => {
      currentTimeLineRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }, 0);
    // Add zoomlevel to dependencies to scroll to selected time upon zoom change
  }, [selectedTime, focusKoppelingActive, zoomLevel]);

  const left = selectedTime.diff(scenarioStart).as("hours") * hourWidth;

  return (
    <div
      ref={currentTimeLineRef}
      className="absolute top-0 h-full bg-default-inverse"
      style={{
        left: `${TIMELINE_PADDING + left - TIMELINE_DRAGGABLE_TIME_LINE_WIDTH / 2}px`,
        minHeight: `${stageHeight}px`,
        width: `${TIMELINE_DRAGGABLE_TIME_LINE_WIDTH}px`,
      }}
    />
  );
}
